import CollapsibleCardFormatter from 'crm-cards-sdk/card-formatters/CollapsibleCardFormatter';
import { CARD_FORMATTER_IFRAME_LOOKUP_KEYS } from 'crm-cards-sdk/constants/IframeLookupKeys';
import { useLocationService } from '../LocationServiceContext';
import { jsx as _jsx } from "react/jsx-runtime";
function CollapsibleCardFormatterWithAPI(props) {
  const {
    updateIsCardCollapsed
  } = useLocationService();
  return /*#__PURE__*/_jsx(CollapsibleCardFormatter, Object.assign({}, props, {
    onCollapseCard: updateIsCardCollapsed
  }));
}
CollapsibleCardFormatterWithAPI.iframeLookupKey = CARD_FORMATTER_IFRAME_LOOKUP_KEYS.COLLAPSIBLE_CARD_FORMATTER_WITH_API;
export default CollapsibleCardFormatterWithAPI;